module.exports = __webpack_public_path__ + "media/custom-icons.092d7628e8fef48e34625a030ae68c22.woff";